import React, { useState } from "react";
import './RegisterInterestModal.css';  

const RegisterInterestModal = ({ isOpen, onClose }) => {
  const [formData, setFormData] = useState({
    firstName: "",
    phoneNumber: "",
    address: "",
    email: "",
    course: "",
  });

  if (!isOpen) return null; // Don't render if modal is not open

  // Handle input change
  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  // Handle form submission
  const handleSubmit = () => {
    const { firstName, phoneNumber, address, email, course } = formData;

    // Ensure required fields are filled
    if (!firstName || !phoneNumber || !address || !course) {
      alert("Please fill in all required fields.");
      return;
    }

    // Construct email content
    const subject = encodeURIComponent("New Course Enquiry");
    const body = encodeURIComponent(
      `Hello,\n\nA new enquiry has been submitted:\n\n` +
      `First Name: ${firstName}\n` +
      `Phone Number: ${phoneNumber}\n` +
      `Address: ${address}\n` +
      `Email: ${email || "Not Provided"}\n` +
      `Course: ${course}\n\nThank you.`
    );

    // Open email client with pre-filled details
    window.location.href = `mailto:rdtcsingawal@gmail.com?subject=${subject}&body=${body}`;
  };

  return (
    <div className="modal-overlay">
      <div className="modal-content">
        <div className="flex justify-between items-center mb-4">
          <h2 className="modal-title">REGISTER YOUR INTEREST</h2>
          <button onClick={onClose} className="modal-close">
            ✖ Close
          </button>
        </div>

        <div className="modal-form">
          <input
            type="text"
            name="firstName"
            placeholder="First Name*"
            className="modal-input"
            value={formData.firstName}
            onChange={handleChange}
          />
          <input
            type="tel"
            name="phoneNumber"
            placeholder="Phone Number*"
            className="modal-input"
            value={formData.phoneNumber}
            onChange={handleChange}
          />
          <input
            type="text"
            name="address"
            placeholder="Address*"
            className="modal-input"
            value={formData.address}
            onChange={handleChange}
          />
          <input
            type="email"
            name="email"
            placeholder="Email (Optional)"
            className="modal-input"
            value={formData.email}
            onChange={handleChange}
          />
          <select
            name="course"
            className="modal-input"
            value={formData.course}
            onChange={handleChange}
          >
            <option value="">Select Course*</option>
            <option>Heavy Vehicle Training</option>
            <option>Light Vehicle Training</option>
            <option>Motorcycle Training</option>
            <option>One-Day Refresher Training</option>
            <option>Pre-License Training</option>
            <option>Saudi Arabia Training Program</option>
          </select>
        </div>

        <button className="modal-button" onClick={handleSubmit}>
          ENQUIRE NOW →
        </button>
      </div>
    </div>
  );
};

export default RegisterInterestModal;
